// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Ee1s","content":"styles_content__3j8yr","selectAll":"styles_selectAll__vzyew"};